import { PlusCircleOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client/react';
import { Button } from 'antd';
import type React from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router';
import { mayReorder, startReorder } from '../../hooks/startReorder';
import { REQUEST_FOR_REORDER_QUERY } from '../../hooks/startReorder.gql';

// Loads its Anforderung itself, so it does not depend on the list page the details were opened from
export const ReorderButton: React.FC<{ requestId: string | null }> = ({ requestId }) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const allowed = !!requestId && mayReorder(auth.user);
  const { data } = useQuery(REQUEST_FOR_REORDER_QUERY, {
    variables: { id: requestId ?? '' },
    skip: !allowed,
    fetchPolicy: 'cache-and-network',
  });
  const request = data?.request;

  if (!allowed || !request?.reorderable) {
    return null;
  }
  return (
    <Button type="default" icon={<PlusCircleOutlined />} onClick={() => startReorder(request, navigate, { user: auth.user })}>
      Nachforderung
    </Button>
  );
};
